import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, Toggle, CircularProgress } from "material-ui"
import strings from "../../../localization/strings"
import { IDate, IPayrollPayCalendar, EExceptionType, ECustomReportType, ICustomReportDocument, IUserFilter } from "../../../models"
import DateRangeSelect from "../../../components/common/DateRangeSelect"
import * as reportAction from "../../../actions/ReportAction"
import AccountStore from "../../../stores/AccountStore"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import moment from "moment"
import * as timecardHelper from "../../../helpers/timecardHelper"
import * as payrollHelper from "../../../helpers/payrollHelper"
import * as api from "../../../api"

interface IProps {
	referenceDate: IDate
	selectedPayrollPayCalendar: IPayrollPayCalendar
	userFilter: IUserFilter
	handleClose(): void

	// job->Timecard report
	jobId: string

	// Timecard page report
	filterByDefaultHierarchy: boolean
	filterDirectReportsOnly: boolean
	filterByPunchHierarchy: boolean
	filterByException: boolean
	filterExceptions: EExceptionType[]
}
interface IState {
	loading: boolean
	customPunchDetailReportExist: boolean
	includePunchPhoto: boolean
	startDate: IDate
	endDate: IDate
	isValid: boolean
}

export default class PunchDetailReportDialog extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)
		const timecardDates = timecardHelper.getTimecardDateByPayrollPayCalendar(props.referenceDate, props.selectedPayrollPayCalendar)
		this.state = {
			loading: true,
			customPunchDetailReportExist: false,
			includePunchPhoto: false,
			startDate: moment(timecardDates.StartDate).utc(true).format(),
			endDate: moment(timecardDates.EndDate).utc(true).format(),
			isValid: true
		}
		autobind(this)
	}

	componentDidMount() {
		api.getCustomReportsByType(ECustomReportType.TimecardPunchDetailReport).then(res => {
			const customPunchDetailReports = res.data as ICustomReportDocument[]
			this.setState({
				loading: false,
				customPunchDetailReportExist: customPunchDetailReports.length > 0
			})
		})
	}

	handleDownload() {
		this.props.handleClose()
		const payGroupIds = payrollHelper.getPayGroupIdsByPayrollPayCalendar(this.props.selectedPayrollPayCalendar)
		this.props.jobId ?
			reportAction.downloadJobTimecardPunchDetailReport(
				AccountStore.getCurrentAccount().Id,
				this.props.jobId,
				this.state.startDate as string,
				this.state.endDate as string,
				payGroupIds,
				this.state.includePunchPhoto,
				this.props.userFilter
			) :
			reportAction.downloadPunchDetailReport(
				AccountStore.getCurrentAccount().Id,
				this.state.startDate as string,
				this.state.endDate as string,
				HierarchySettingsStore.getGlobalLevelItemFilterId(),
				payGroupIds,
				this.props.userFilter,
				this.props.filterByDefaultHierarchy,
				this.props.filterDirectReportsOnly,
				this.props.filterByPunchHierarchy,
				this.props.filterByException,
				this.props.filterExceptions,
				this.state.includePunchPhoto
			)
	}

	render() {
		return (
			<Dialog
				open
				title={strings.Punch_Detail_Report}
				actions={[
					<FlatButton data-intercom-target={"Timecards-Reports-Btn-ClosePunchDetailReportDialog"} key="cancel" label={strings.CANCEL} secondary onTouchTap={this.props.handleClose} />,
					<FlatButton data-intercom-target={"Timecards-Reports-Btn-DownloadPunchDetailReport"} key="download" label={strings.Download} disabled={!this.state.isValid || this.state.loading} primary onTouchTap={this.handleDownload} />
				]}
			>
				{this.state.loading ?
					<div style={{ textAlign: "center" }}>
						<CircularProgress />
					</div> :
					<div>
						<DateRangeSelect
							startDate={this.state.startDate}
							endDate={this.state.endDate}
							handleChange={(startDate, endDate, isValid) => this.setState({ startDate, endDate, isValid })}
							sameDatesAllowed
						/>
						{!this.state.customPunchDetailReportExist &&
							<Toggle
								toggled={this.state.includePunchPhoto}
								onToggle={(e, includePunchPhoto) => this.setState({ includePunchPhoto })}
								label={strings.Include_Punch_Photo}
								style={{ paddingTop: 10, width: 275 }}
							/>
						}
					</div>
				}

			</Dialog>
		)
	}
}